<template>
    <div class="row textoYBotonConVinculo">
        <div v-for="contenidoDeLaPaginaWeb in seccionDeLaPaginaWeb.ContenidosDeLaPaginaWeb" v-bind:key="contenidoDeLaPaginaWeb.ContenidoDeLaPaginaWebId">
            <span class="text-justify">{{contenidoDeLaPaginaWeb.TextoDelContenido}}</span>
            <div v-if="contenidoDeLaPaginaWeb.ArchivosDeContenidoDeLaPaginaWeb.length > 0" class="col-12 text-right">
                <br/>
                <div v-for="archivoDeContenidoDeLaPaginaWeb in contenidoDeLaPaginaWeb.ArchivosDeContenidoDeLaPaginaWeb" v-bind:key="archivoDeContenidoDeLaPaginaWeb.ArchivoDeContenidoDeLaPaginaWebId">
                    <a v-if="archivoDeContenidoDeLaPaginaWeb.TipoRolDeArchivoEnContenido.TipoRolDeArchivoEnContenidoId == TIPO_ROL_DE_ARCHIVO" class="btn btn-default" v-on:click="AbrirDocumento(archivoDeContenidoDeLaPaginaWeb.RutaDeArchivoCarpeta, '_self');">{{contenidoDeLaPaginaWeb.TextoDelVinculo}}</a>
                </div>
            </div>
            <div v-else class="col-12 text-right">
                <br/>
                <a v-if="contenidoDeLaPaginaWeb.Vinculo.includes('http')" class="btn btn-default" v-on:click="AbrirDocumento(contenidoDeLaPaginaWeb.Vinculo, '_blank');" v-bind:class="CreaLaClaseDeCol(contenidoDeLaPaginaWeb.TamanoDelContenido != null ? contenidoDeLaPaginaWeb.TamanoDelContenido : seccionDeLaPaginaWeb.TamanoDeMiDescendiente)">{{contenidoDeLaPaginaWeb.TextoDelVinculo}}</a>
                <router-link v-else :to="contenidoDeLaPaginaWeb.Vinculo">{{contenidoDeLaPaginaWeb.TextoDelVinculo}}</router-link>
            </div>
        </div>
    </div>
</template>

<script>
import comun from "@/../static/js/comun";
import enumeraciones_sicpo from "@/../static/js/enumeraciones/sicpo.js";

export default {
    data() { 
      return {
        TIPO_ROL_DE_ARCHIVO: 1
      }
    },
    props: {
        seccionDeLaPaginaWeb: Object
    }, 
    methods: {
        AbrirDocumento: function(vinculo, formaDeApertura) {
          //comun.DescargarDocumentoPDF(vinculo)
          comun.DescargarDocumentoPDF(vinculo);
            //window.open(vinculo, formaDeApertura);
        }, 
        CreaLaClaseDeCol: function(tamanoDeLaColumna) {
            return "col-md-" + tamanoDeLaColumna + " col-" + tamanoDeLaColumna;
        }
    }
}
</script>

<style scoped>
  .textoYBotonConVinculo {
    text-align: justify;
  }

  .textoYBotonConVinculo div {
      padding-left: 20px;
      padding-right: 20px;
  }

  .textoYBotonConVinculo a{
    background-color: #931F05;
    border-radius: 9px;
    color:white;
    border-color:#931F05;
  }

  .textoYBotonConVinculo a:hover {
    background-color: rgb(34,34,34);
    border-color: rgb(34,34,34);
    color: white;
  }
</style>


// WEBPACK FOOTER //
// src/components/PaginaOficial/PaginaInformativa/Formatos/TextoYBotonConVinculo.vue